import * as React from "react";

function EarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M192 0C86 0 0 86 0 192v176c0 79.5 64.5 144 144 144s144-64.5 144-144v-9.875C345.4 324.9 384 263 384 192 384 86 298 0 192 0zm71.9 316.6L240 330.5V368c0 52.94-43.06 96-96 96s-96-43.06-96-96V192c0-79.4 64.6-144 144-144s144 64.6 144 144c0 51.1-27.6 98.8-72.1 124.6zM200 80h-16c-57.3 0-104 46.7-104 104v47.97c0 9.9 5.934 18.65 15.12 22.28l28.98 11.58c3.857 1.547 4.746 4.91 4.949 6.283.203 1.367.324 4.826-2.916 7.418L89 309.2c-10.32 8.285-12 23.42-3.756 33.74C89.81 348.6 96.88 352 104.2 352c5.35 0 10.47-1.818 14.81-5.262l37.15-29.71c15.73-12.59 23.36-32 20.4-51.92C173.6 245.2 160.6 228.8 141.9 221.3l-13.9-5.6V184c0-30.9 25.1-56 56-56h16c30.9 0 56 25.1 56 56 0 13.23 10.77 24 24 24s24-10.77 24-24c0-57.3-46.7-104-104-104zm-95.8 264c-.41 0-.754-.242-1.158-.273 1.154.09 2.32.062 3.502-.12-.844.093-1.644.393-2.344.393z"
  }));
}

const ForwardRef = React.forwardRef(EarIcon);
export default ForwardRef;